<template>
  <span style="margin-right: 5px">
    <el-button :type="type" :size="size" @click="approveBeneficiary()">
      Approve
    </el-button>

    <el-dialog
      title="Approve beneficiary"
      :visible.sync="dialogApprove"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      append-to-body
    >
      <span>Are you sure you need to approve this beneficiary?</span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogApprove = false">Cancel</el-button>
        <el-button
          type="primary"
          @click="updateStatusBeneficiary()"
          :loading="submitting"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { getToken } from "@/utils/auth";
import {
  updateStatusBeneficiary,
  getBeneficiaryDocument,
} from "@/api/beneficiary-monitor";
export default {
  components: {
   
  },
  props: {
    uid: {
      type: String,
      default: "",
    },
    info: Object,
    type: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: "mini",
    },
  },
  data() {
    return {
      dialogApprove: false,
      formData: {},
      submitting: false,
      documentLists: [],
    };
  },
  methods: {
    approveBeneficiary() {
      this.getFileList();
      this.documentLists = [];
      this.dialogApprove = true;
    },
    fileDownload(file) {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.originFilename;
      link.target = "_blank";
      link.click();
    },
    updateStatusBeneficiary() {
      var model = {
        status: "approve",
      };
      this.submitting = true;
      updateStatusBeneficiary(this.uid, model).then(({ result, message }) => {
        this.submitting = false;
        if (result) {
          this.$emit("onSuccess");
          this.dialogApprove = false;
          this.$notify({
            title: "Success",
            message: `Update successfully`,
            type: "success",
            duration: 2000,
          });
        } else {
          this.$notify({
            title: "Error",
            message: message,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    mapFileList(data) {
      if (!data) return [];
      data.forEach((element) => {
        element.url = `${
          process.env.VUE_APP_SERVER_BASE_API
        }/api/beneficiary-firewall/media/${
          element.filename
        }?token=${getToken()}`;

        element.name = element.filename;
      });
      return data;
    },

    getFileList() {
      this.loadingDocument = true;
      this.actionUpload = `${process.env.VUE_APP_SERVER_BASE_API}/api/beneficiary-firewall/beneficiarys/${this.info.uid}/documents`;
      getBeneficiaryDocument(this.uid).then(({ result, data }) => {
        this.loadingDocument = false;
        if (result) {
          this.documentLists = this.mapFileList(data);
        }
      });
    },
  },
  mounted() {
    
  },
};
</script>

<style>
</style>